import { ReactNode } from "react";
import {
  MRT_EditActionButtons as MRTEditActionButtons,
  MRT_Row,
  MRT_TableInstance
} from "material-react-table";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { TransitionForSlideoutPanel } from "../SlideoutPanel/SlideoutPanelTransition.component";

export function CategoryTableSlideoutPanel({
  table,
  row,
  internalEditComponents,
  categoryType,
  headline,
  typeSection
}: Readonly<{
  table: MRT_TableInstance<any>;
  row: MRT_Row<any>;
  internalEditComponents: ReactNode[];
  categoryType: string;
  headline: string;
  /** When provided (e.g. for booking-property), rendered instead of internalEditComponents[2],[3],[4] */
  typeSection?: ReactNode;
}>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const slideoutPanelStyle = {
    position: "absolute",
    right: 0,
    margin: 0,
    padding: 3,
    height: "calc(-64px + 100vh)",
    maxHeight: "calc(-64px + 100vh)",
    maxWidth: isMobile ? "inherit" : "50vw",
    width: isMobile ? "100%" : "40vw",
    top: "64px"
  };

  return (
    <Dialog
      open
      data-testid={`${categoryType}-slideout-panel-dialog`}
      slotProps={{ paper: { sx: { ...slideoutPanelStyle } } }}
      transitionDuration={400}
      slots={{ transition: TransitionForSlideoutPanel }}
    >
      {/* edit equipment dialog contents */}
      <DialogTitle variant="h4">{headline}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", mt: 2 }}>
        <Grid2 container data-testid={`${categoryType}-slideout-panel-contents`} columnGap={4}>
          <Grid2 container size={{ xs: 12 }} rowGap={5}>
            {/* name */}
            {internalEditComponents[0]}
            {/* description now, instead of image url */}
            {internalEditComponents[1]}
            {/* booking-property: type switches section; other categories: cost factor */}
            {typeSection ??
              (categoryType === "booking-property" ? (
                <>
                  {internalEditComponents[2]}
                  {internalEditComponents[3]}
                  {internalEditComponents[4]}
                </>
              ) : (
                internalEditComponents[2]
              ))}
          </Grid2>
        </Grid2>
      </DialogContent>

      <Divider sx={{ mt: 3, mb: 3, opacity: "0.6" }} />

      <DialogActions>
        <MRTEditActionButtons variant="text" table={table} row={row} />
      </DialogActions>
    </Dialog>
  );
}
